<div class="page-wrapper">
  <div class="middle-container">
    <qai-inner-wrap>
      <div class="sim-header">
        <div class="simulation-heading">
          <h2 class="heading">Simulation Builder</h2>
          <div>
            <qai-floating-select
              *ngIf="!hasSingleEligibleAccount"
              [options]="options"
              [placeholder]="'Select an option'"
              [placement]="'below-start'"
              [offset]="4"
              [shape]="'round'"
              [value]="selectedAccount?.value"
              (valueChange)="valueChange($event)"
              (selectionChange)="selectionChange($event)"
            ></qai-floating-select>
          </div>
        </div>

        <!-- Create buttons based on selected account roles -->
        <button-floating-select
          *ngIf="
            selectedAccountHasAssignmentManager && selectedAccountHasAuthor
          "
          [options]="createModuleOptions"
          buttonLabel="Create new"
          buttonIcon="plus"
          (optionSelected)="handleCreateOptions($event)"
        ></button-floating-select>

        <button
          *ngIf="
            selectedAccountHasAssignmentManager && !selectedAccountHasAuthor
          "
          qai-button
          [shape]="'normal'"
          [kind]="'primary'"
          [size]="'medium'"
          (click)="openAssignmentModal()"
        >
          <qai-icon kind="plus" positionStart />
          Create new assignment
        </button>

        <button
          qai-button
          *ngIf="
            selectedAccountHasAuthor && !selectedAccountHasAssignmentManager
          "
          [shape]="'normal'"
          [kind]="'primary'"
          [size]="'medium'"
          (click)="openModal(EntityType.SIMULATION, EntityActionType.CREATE)"
        >
          <qai-icon kind="plus" positionStart />
          Create new simulation
        </button>
      </div>

      <qai-tabs
        (tabSelected)="onTabChange($event)"
        *ngIf="shouldShowAssignmentsTab && shouldShowSimulationsTab"
      >
        <ng-template qaiTab="uniqueId1" label="Assignments">
          <app-assignments
            [selectedAccount]="selectedAccount"
            [selectedAccountUuid]="selectedAccountUuid"
            (deleteAssignment)="onDeleteItem(EntityType.ASSIGNMENT, $event)"
            (duplicateAssignment)="onDuplicateAssignment($event)"
          ></app-assignments>
        </ng-template>

        <ng-template qaiTab="uniqueId2" label="Simulations">
          <app-assignment-simulations
            [selectedAccount]="selectedAccount"
            [selectedAccountUuid]="selectedAccountUuid"
            (deleteSimulation)="onDeleteItem(EntityType.SIMULATION, $event)"
            (duplicateSimulation)="onDuplicateSimulation($event)"
            [refreshKey]="simulationsRefreshKey"
          ></app-assignment-simulations>
        </ng-template>
      </qai-tabs>

      <!-- Show only Simulations tab -->
      <div *ngIf="!shouldShowAssignmentsTab && shouldShowSimulationsTab">
        <app-assignment-simulations
          [selectedAccount]="selectedAccount"
          [selectedAccountUuid]="selectedAccountUuid"
          (deleteSimulation)="onDeleteItem(EntityType.SIMULATION, $event)"
          (duplicateSimulation)="onDuplicateSimulation($event)"
          [refreshKey]="simulationsRefreshKey"
        ></app-assignment-simulations>
      </div>

      <div *ngIf="shouldShowAssignmentsTab && !shouldShowSimulationsTab">
        <app-assignments
          [selectedAccount]="selectedAccount"
          [selectedAccountUuid]="selectedAccountUuid"
          (deleteAssignment)="onDeleteItem(EntityType.ASSIGNMENT, $event)"
          (duplicateAssignment)="onDuplicateAssignment($event)"
        ></app-assignments>
      </div>
    </qai-inner-wrap>
  </div>
</div>

<assignment-modal
  [open]="isAssignmentModalVisible"
  (assignmentSave)="handleAssignmentSave($event, true)"
  (handleSaveAndClose)="handleAssignmentSave($event, false)"
  (closeAssignmentModal)="closeAssignmentModal()"
  [networkRequestInProgress]="assignmentRequestInProgress"
></assignment-modal>

<action-modal
  [open]="modalOpen"
  [entityType]="modalEntityType"
  [entityActionType]="modalActionType"
  [originalName]="modalOriginalName"
  [networkRequestInProgress]="networkRequestInProgress"
  [errorStatus]="modalErrorStatus"
  (confirmAction)="onModalConfirmed($event)"
  (closeModal)="closeModal()"
></action-modal>

<delete-modal
  [open]="isDeleteModalOpen"
  (openChange)="isDeleteModalOpen = $event"
  (confirm)="handleDeleteConfirmed()"
  (closeModal)="closeDeleteModal()"
  [networkRequestInProgress]="networkRequestInProgress"
  [type]="deleteContext?.type || EntityType.ASSIGNMENT"
  [assignmentStatus]="assignmentStatusLabel"
  [moduleUuid]="deleteContext?.moduleUuid"
></delete-modal>

<add-simulation-to-assignment-modal
  [open]="addSimulationsToAssignmentModalOpen"
  (backAndCloseModal)="closeAddSimulationAndOpenAssignmentModal()"
  (closeSimulationModal)="closeAddSimulationToAssignmentModal()"
  [moduleAssignmentUuid]="moduleAssignmentUuid"
  [moduleUuid]="moduleUuid"
  (simulationAssigned)="handleSimulationAssigned()"
  [modalHeading]="'Create new assignment'"
  [isCreateAssignmentFlow]="true"
></add-simulation-to-assignment-modal>

<add-users-to-assignment-modal
  [open]="isUserAssignmentModalVisible"
  [moduleAssignmentUuid]="moduleAssignmentUuid"
  (closeModal)="closeUserAssignmentModal()"
  [networkRequestInProgress]="networkRequestInProgress"
  (addToAssignmentClicked)="handlePostUserAssignmentModal()"
  [currentAssignees]="[]"
  [isCreateAssignmentFlow]="true"
></add-users-to-assignment-modal>
